import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { NotificationsService } from './notificationsApi';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import { AxiosError } from 'axios';

const initialState: any = {
    notificationsAreLoading: false,
    notificationIsLoading: false,
    requestStatus: 'default',
    message: '',
};


export const tryToFetchNotifications = createAsyncThunk<any, IPaginationPayload>(
    'notifications/tryToFetchNotifications',
    async ({ pageNumber, pageSize, filters, data }) => {
        const result = await NotificationsService.tryToFetchNotifications(
            pageNumber,
            pageSize,
            data,
            filters,
        );
        return result?.data;
    },
);


export const tryToFetchNotificationsSidebar = createAsyncThunk<any, IPaginationPayload>(
    'notifications/tryToFetchNotificationsSidebar',
    async ({ pageNumber, pageSize, filters, data }) => {
        const result = await NotificationsService.tryToFetchNotifications(
            pageNumber,
            pageSize,
            data,
            filters,
        );
        return result?.data;
    },
);

export const tryToMarkNotificationsAsRead = createAsyncThunk<any, any>(
    'notifications/tryToMarkNotificationsAsRead',
    async (data, { rejectWithValue }) => {
        try {
            const result = await NotificationsService.tryToMarkNotificationsAsRead(data);
            return result.data?.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    },
);

export const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchNotifications
            .addCase(tryToFetchNotifications.pending, (state) => {
                state.notificationsAreLoading = true;
            })
            .addCase(tryToFetchNotifications.rejected, (state) => {
                state.notificationsAreLoading = false;
            })
            .addCase(tryToFetchNotifications.fulfilled, (state, action) => {
                state.notificationsAreLoading = false;
                state.notifications = action.payload;
            })

            // tryToFetchNotificationsSidebar
            .addCase(tryToFetchNotificationsSidebar.pending, (state) => {
                state.notificationsAreLoading = true;
            })
            .addCase(tryToFetchNotificationsSidebar.rejected, (state) => {
                state.notificationsAreLoading = false;
            })
            .addCase(tryToFetchNotificationsSidebar.fulfilled, (state, action) => {
                state.notificationsAreLoading = false;
                state.notificationsSidebar = action.payload;
            })
    },
});

export default notificationsSlice.reducer;